import LandingPage from './Landing';

export default LandingPage;
